'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SiteId$() {
  this.caH = null;
  this.caI = false;
  this.caF = null;
  this.caG = false;
}
export { $c_Lpresto_types$SiteId$ as $c_Lpresto_types$SiteId$ };
$p = $c_Lpresto_types$SiteId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteId$;
/** @constructor */
function $h_Lpresto_types$SiteId$() {
}
export { $h_Lpresto_types$SiteId$ as $h_Lpresto_types$SiteId$ };
$h_Lpresto_types$SiteId$.prototype = $p;
$p.sC = (function() {
  if ((!this.caI)) {
    this.caH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j1;
    this.caI = true;
  }
  return this.caH;
});
$p.iM = (function() {
  if ((!this.caG)) {
    this.caF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB;
    this.caG = true;
  }
  return this.caF;
});
var $d_Lpresto_types$SiteId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteId$, "presto.types$SiteId$", ({
  a28: 1,
  D: 1
}));
export { $d_Lpresto_types$SiteId$ as $d_Lpresto_types$SiteId$ };
var $n_Lpresto_types$SiteId$;
function $m_Lpresto_types$SiteId$() {
  if ((!$n_Lpresto_types$SiteId$)) {
    $n_Lpresto_types$SiteId$ = new $c_Lpresto_types$SiteId$();
  }
  return $n_Lpresto_types$SiteId$;
}
export { $m_Lpresto_types$SiteId$ as $m_Lpresto_types$SiteId$ };
//# sourceMappingURL=presto.types$-Site-Id$.js.map
